import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import isEmpty from 'lodash/isEmpty';
import { getAuthBearerToken } from 'src/utils/get-auth-with-bearer';

const USER_SCHEMA = z.object({
  username: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string().email(),
  groups: z.array(z.string()),
});

export type GetUserSchema = z.infer<typeof USER_SCHEMA>;

export const getUserPromise = async () => {
  try {
    const bearerToken = getAuthBearerToken();

    if (!bearerToken) {
      throw new Error('Missing bearerToken');
    }

    const response = await ky
      .get(`${ENV.API_URL}/api/users/`, {
        headers: {
          Authorization: bearerToken,
        },
      })
      .json();

    const result = USER_SCHEMA.safeParse(response);

    if (!result.success) {
      throw new Error('Invalid response');
    }

    const isLoggedIn =
      !isEmpty(result.data?.email) &&
      !isEmpty(result.data?.username) &&
      result.data?.username?.toLowerCase() !== 'anonymous_user';

    if (!isLoggedIn) {
      throw new Error('Anonymous user');
    }

    return {
      userDetails: result.data,
      isLoggedIn,
    };
  } catch (error) {
    console.error('Error fetching user data:', error);

    return {
      userDetails: null,
      isLoggedIn: false,
    };
  }
};
